import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Container,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import {  withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../components/Common/Breadcrumb_2Items";
import { postSubmitForm } from "../../../helpers/forms_helper";
import showNotification from "../../../helpers/show_notification";
import PlaceOrder from "../../../components/Orders/Items/PlaceOrder";

const AddNewItemOrder = (props) => {
  const storeName = localStorage.getItem("store_name")

  useEffect(() => {
    loadAllStores();
  }, []);

 
  const [allStores, setAllBranches] = useState([]);

  const loadAllStores = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const result2 = response.data.filter((store) =>   store.type === "Sub Store" || store.type === "Main Store" && store.name !== storeName)
      setAllBranches(result2);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [allItems, setAllItems] = useState([]);
  const [isLoadingItems, setIsLoadingItems] = useState(false);
  const loadItemsRequestId = useRef(0);
  const loadItems = async (data) => {
    const requestId = ++loadItemsRequestId.current;
    try {
      setIsLoadingItems(true);
      setAllItems([]);
      let url = process.env.REACT_APP_BASEURL + "items/get_mapped_items";
      const response = await postSubmitForm(url, data);
      if (requestId !== loadItemsRequestId.current) return;
      if (response && response.status === 1) {
        const updatedItems = (response.data || []).filter((d)=>d.is_active);
        const selectOptions = updatedItems.map(item => ({
          _id:item.item_id,
          name:item.name,
          unit_levels:item.unit_levels,
          available:item.available,
          store_available:item.store_available,
          threshold:item.threshold,
          unit_for_threshold:item.unit_for_threshold,
          unit_for_max_order:item.unit_for_max_order,
          max_order_limit:item.max_order_limit,
          category:item.category,
          sub_category:item.sub_category,
          label: item.name,
          value: item.item_id
        }));
        setAllItems(selectOptions);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      if (requestId === loadItemsRequestId.current) {
        showNotification(error, "Error");
      }
    } finally {
      if (requestId === loadItemsRequestId.current) {
        setIsLoadingItems(false);
      }
    }
  };

  function loadStoreItems (data){
loadItems({store_id:data._id})
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Orders")}
            alternateTitle={props.t("Items")}
            breadcrumbItem1={props.t("Items")}
            breadcrumbItem2={props.t("Add New Order")}
          />
        <PlaceOrder 
        allStores={allStores}
        allItems={allItems}
        isLoadingItems={isLoadingItems}
        onStoreSelect={loadStoreItems}
        />

        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(AddNewItemOrder))
);
